import React from "react";
import NightAuditFolioItemsProducts from "./NightAuditFolioItemsProducts";
import NightAuditFolioItemsSummary from "./NightAuditFolioItemsSummary";
import NightAuditFolioItemsLodging from "./NightAuditFolioItemsLodging";
import NightAuditFolioItemsTaxes from "./NightAuditFolioItemsTaxes";
import NightAuditFolioItemsFees from "./NightAuditFolioItemsFees";
import DatePickerInput from "../../../DatePickerInput/DatePickerInput";
import DateHelper from "../../../DateHelper/DateHelper";

class NightAuditFolioItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false, 
      summary: null, 
    };
  };

  render() {
    return(
      <div>
        <div className="alert alert-warning show">
          <h4 style={{ textAlign: 'center' }}><strong>{I18n.t('all_folio_items_listed_helper_text')}</strong></h4> 
        </div>
        {this.renderDatePicker()}
        {/* <NightAuditFolioItemsSummary
          {...this.props}
          formatCurrency={this.props.formatCurrency}
          summary={this.state.summary} /> */}
        <br/>
        <NightAuditFolioItemsLodging {...this.props}/>
        <br/>
        {/* {this.renderProducts()} */}
        <br/>
        {/* <NightAuditFolioItemsTaxes {...this.props}/>
        <br/> */}
        {/* <NightAuditFolioItemsFees {...this.props}/> */}
        <br/>
      </div>
    );
  };

  renderDatePicker() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t('post_date')}</h3>
          <div className="col-sm-2 post-date-wrapper">
            <DatePickerInput 
              minDate={this.props.last_audit ? DateHelper.parseDateFromBackend(this.props.last_audit.post_date) : null}
              selectedDate={this.props.postDate}
              dateFormat={this.props.date_format} 
              onChange={this.props.onChangePostDate}
              popperPlacement='bottom-end'
               />
          </div>
        </div>
      </div>
    );
  };

  renderProducts() {
    return this.props.products.map(product => <NightAuditFolioItemsProducts {...this.props} product={product} key={product.id}/>)
  };
};

export default NightAuditFolioItems